import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { UiStore, UiState } from './ui.store';
import { Observable } from 'rxjs';
import { KeyboardState } from '@core/models/KeyboardState';

@Injectable({ providedIn: 'root' })
export class UiQuery extends Query<UiState> {

    constructor(protected store: UiStore) {
        super(store);
    }

    public selectLoading(): Observable<boolean> {
        return this.select('showLoader');
    }

    public selectManualLoading(): Observable<boolean> {
        return this.select('showManualLoader');
    }

    public isLoading(): boolean {
        return this.getValue().showLoader;
    }

    public isManualLoading(): boolean {
        return this.getValue().showManualLoader;
    }

    public selectSkeleton(): Observable<boolean> {
        return this.select('showSkeleton');
    }

    public selectLabelsLoaded(): Observable<boolean> {
        return this.select('labelsLoaded');
    }

    public selectInitError(): Observable<string | null> {
        return this.select('initError');
    }

    public selectKeyboardState(): Observable<KeyboardState> {
        return this.select('keyboardState');
    }
}
